import {
  GET_SKILLS_REQUEST, GET_SKILLS_FAIL, GET_SKILLS_SUCCESS
} from "../constants/AuthConstant";

const initialState = {
  loading: false,
  action: "Job Action",
  result: [],
  msg: "",
  error: "",
};

const CandidateSkillReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SKILLS_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case GET_SKILLS_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case GET_SKILLS_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default CandidateSkillReducer;
